// extracted by mini-css-extract-plugin
export var contrastLow = "_i-1";
export var externalLink = "_i-2";
export var externalLinkIcon = "_i-3";
export var link = "_i-0";
export var linkLabel = "_i-4";